// injectCsrfTokenForInterceptor

import {
  injectCsrfTokenForInterceptor,
  injectStateIntoLogger,
  authenticatedUserState,
  csrfTokenState,
  impersonatedUserState
} from '@sd/shared';
import { useRecoilValue } from 'recoil';

/**
 * Used to connect internal recoil state to stateless objects
 * such as API Clients and the global logger.
 */
export const ConnectRecoilState = () => {
  const csrfToken = useRecoilValue(csrfTokenState);
  const user = useRecoilValue(authenticatedUserState);
  const impersonatedUser = useRecoilValue(impersonatedUserState);
  injectCsrfTokenForInterceptor(csrfToken);
  injectStateIntoLogger({ user, impersonatedUser });

  return null;
};
